import { render, staticRenderFns } from "./Privileges.vue?vue&type=template&id=6602cb2e&scoped=true"
import script from "./Privileges.vue?vue&type=script&lang=js"
export * from "./Privileges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602cb2e",
  null
  
)

export default component.exports